import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="h-10 w-10 text-yellow-600" />
        </div>
        <h2 className="text-2xl font-display font-bold text-primary mb-2">
          Pagamento Cancelado
        </h2>
        <p className="text-text-secondary mb-6">
          Você cancelou o processo de pagamento. Sua reserva não foi confirmada.
        </p>
        <div className="space-y-3">
          <Button
            className="w-full bg-primary hover:bg-primary/90 rounded-full"
            onClick={() => navigate('/rooms')}
            data-testid="back-to-rooms-button"
          >
            Voltar aos Quartos
          </Button>
          <Button
            variant="outline"
            className="w-full rounded-full"
            onClick={() => navigate('/')}
          >
            Voltar ao Início
          </Button>
        </div>
      </div>
    </div>
  );
};
